module.exports = __webpack_public_path__ + "img/ttshop_dsh.826103d8.svg";